import React from 'react';
import NameDefinition from './NameDefinition';
import Icon from '@mdi/react';
import PropTypes from 'prop-types';
import { mdiFinance } from '@mdi/js';

const RoiDefinition = ({
  showIcon,
  definition = 'Return on Investment: Net Profit / Ad Spent',
  textFormat = 'text-xs font-semibold w-fit text-background-dark',
  size,
}) => {
  return (
    <div className='flex items-center gap-2'>
      {showIcon && <Icon path={mdiFinance} size={0.8} className='text-orange' />}
      <NameDefinition name='ROI' definition={definition} textSize={textFormat} size={size} />
    </div>
  );
};

export default RoiDefinition;

RoiDefinition.propTypes = {
  showIcon: PropTypes.object,
  textFormat: PropTypes.string,
};
